<template>
  <slider :items="items" :config="config">
    <template v-slot:body="{ item, index }">
      <slide
        :key="index"
        :overlay="overlay"
        :paths="{
          xlarge: item.xLargeFileUrl,
          large: item.largeFileUrl,
          medium: item.mediumFileUrl,
          small: item.smallFileUrl,
        }"
      >
        <div
          class="relative py-12 px-4 lg:py-20 lg:px-8 lg:items-center text-center mx-auto max-w-screen-xl z-10"
          v-html="item.body"
        ></div>
      </slide>
    </template>
    <template v-slot:navigation v-if="items.length > 1">
      <div class="swiper-pagination absolute hidden lg:inline-block"></div>
    </template>
  </slider>
</template>
<script>
import Slider from '../Slider';
import Slide from './Slide';
export default {
  name: 'SlideShow',
  components: { Slider, Slide },
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    config: {
      type: Object,
      default: () => {
        return {};
      },
    },
    overlay: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
